import React from "react";
import '../../assets/css/style.css';

const Page404 = () => {
  return (
    <div className="App">
      <div className="page404">
        <i className="fas fa-exclamation-triangle fa-5x" />
        <h1 className="display-3">404</h1>
        <h4>Oops! You{'\''}re lost.</h4>
        <p className="float-left">The page you are looking for was not found.</p>
      </div>
    </div>
  );
}
export default Page404;